import { isElasticLoad, isToday, groupBy } from "../helpers/common";
import moment from "moment";
import { secondsToTime, graphDateString } from "../helpers/moment-ex";
import { API_DATE_FORMAT } from "../constants";

export const getWorkedAcres = (workedData, isDataUntilNow) => {
    const worked = { workedAcres: 0, isLinearAcres: false };
    const data = !isDataUntilNow && workedData.today_data ? workedData.today_data : workedData.data;

    if (data && data.hasOwnProperty("linear_hectares")) {
        worked.workedAcres = (data.linear_hectares * 2.47105);
        worked.isLinearAcres = true;
    }
    else if (data && data.hasOwnProperty("worked_hectares")) {
        worked.workedAcres = (data.worked_hectares * 2.47105);
    }
    return worked;
}

export const getWorkedLocation = (workedData, type, isDataUntilNow) => {
    let location = [];
    const gridType = !isDataUntilNow ? "today_grid" : "grid";
    if (!(workedData && workedData[gridType] && workedData[gridType][type] &&
        Array.isArray(workedData[gridType][type]) && workedData[gridType][type].length > 0)) return location;
    workedData[gridType][type].forEach(data => {
        location.push(data.coordinates[0].map(e => ({ lat: e[1], lng: e[0] })));
    });
    return location;
}


export const mergeFarmSummaryKPI = (planTypeId, state, payload, defaultAnalyseValues) => {
    if (!(payload && payload.data)) return;

    const { summary } = state.summaryByPlanTypeId[planTypeId];
    const { isLive, data } = payload;
    const message = { ...data };
    let completedAcres = null;


    if (isLive) {
        completedAcres = message.summary && message.summary.work && !isNaN(message.summary.work.acres) ? message.summary.work.acres : null;
    }
    else {
        //Farm KPI
        const farmId = state.farmId;
        if (!(farmId && message[farmId])) return;

        const data = getCompleted(message);
        completedAcres = data.completedAcres;
    }

    if (completedAcres === null) return;

    //completed acres
    let acres = null;

    if (completedAcres > 0) {
        acres = summary && summary.acres ? summary.acres : defaultAnalyseValues.summary.acres;
        acres = {
            ...acres,
            completed: completedAcres,
            remaining: (acres.planned > completedAcres) ? (acres.planned - completedAcres) : 0
        }
    }

    return {
        summary: {
            ...summary,
            ...acres ? { acres } : {},
        }
    };
}

const getCompleted = message => {
    let completedAcres = 0;

    for (const key in message) {
        if (!(message[key].data && Array.isArray(message[key].data))) continue;
        const data = message[key].data;

        for (const item of data) {
            completedAcres += item.summary && item.summary.work && !isNaN(item.summary.work.acres) ? item.summary.work.acres : 0;
        }
    }

    return { completedAcres };
};

export const mergeFarmLoadKPI = (planTypeId, state, payload) => {
    if (!payload) return;
    if (!isElasticLoad()) return;

    const { isLive, data } = payload;
    return isLive ? farmLiveLoad(planTypeId, state, data) : farmHistoricalLoad(planTypeId, state, data);
}

const farmLiveLoad = (planTypeId, state, message) => {

    if (!message) return;
    const { summary } = state.summaryByPlanTypeId[planTypeId];

    //Farm load
    let loadCount = 0;
    if (message.hasOwnProperty("load_count_estimate")) loadCount = parseInt(message.load_count_estimate);
    else if (message.hasOwnProperty("load_count")) loadCount = parseInt(message.load_count);
    if (loadCount <= 0) return;

    return {
        summary: {
            ...summary,
            load: { totalLoads: loadCount }
        }
    };
}

const farmHistoricalLoad = (planTypeId, state, message) => {
    if (!(message && message.data)) return;

    const { summary } = state.summaryByPlanTypeId[planTypeId];

    const farmId = state.farmId;
    if (!message.data[farmId]) return;

    const load = message.data[farmId];
    const loadCount = load.hasOwnProperty("load_count") ? parseInt(load.load_count) : 0;

    //Farm load
    if (loadCount <= 0) return;
    return {
        summary: {
            ...summary,
            load: { totalLoads: loadCount }
        }
    };

}

export const mergeFarmGraphKPI = (planTypeId, range, state, payload, defaultAnalyseValues, timezone) => {
    if (!(payload && payload.data)) return;

    const farmId = state.farmId;
    const { graph } = state.summaryByPlanTypeId[planTypeId];

    const { isLive, data } = payload;
    let message = { ...data };

    let graphInfo = {};
    if (isToday(range)) {
        if (!isLive) {
            message = data[farmId] && Array.isArray(data[farmId].data) &&
                data[farmId].data.length > 0 ? data[farmId].data[0] : null;
        }

        graphInfo = todayGraphForFarm(planTypeId, state, message, timezone, defaultAnalyseValues);
    }
    else {
        graphInfo = historicalGraphForFarm(planTypeId, state, message, timezone, defaultAnalyseValues);
    }

    return { graph: { ...defaultAnalyseValues.graph, ...graph, ...graphInfo } };
}

const todayGraphForFarm = (planTypeId, state, message, timezone, defaultAnalyseValues) => {
    if (!(message && message.work_day && message.work_day.start_time)) return;
    if (!(message.detail && Array.isArray(message.detail.work) && message.detail.work.length > 0)) return;
    let actualLine = [], trendLine = [], plannedLine = [];

    let { graph } = state.summaryByPlanTypeId[planTypeId];
    graph = graph ? graph : defaultAnalyseValues.graph;
    const workDayStart = moment.utc(message.work_day.start_time).tz(timezone);
    const workDayEnd = moment.utc(message.work_day.end_time).tz(timezone);
    const startOfDay = workDayStart.clone().startOf('day');
    const endOfDay = workDayStart.clone().endOf('day').add("seconds", 1);

    //----------------Planned line calculation----------------------
    const plannedActivity = graph.planned_activity;
    if (plannedActivity.length > 0) {
        const plannedAcres = plannedActivity[0].acres;
        plannedLine.push({ time: startOfDay, acres: 0, ts: startOfDay.valueOf() });
        plannedLine.push({ time: workDayStart, acres: 0, ts: workDayStart.valueOf() });
        plannedLine.push({ time: workDayEnd, acres: plannedAcres, ts: workDayEnd.valueOf() });
        plannedLine.push({ time: endOfDay, acres: plannedAcres, ts: endOfDay.valueOf() });
        plannedLine = plannedLine.map(e => [graphDateString(e.time), e.acres]);
    }
    //--------------------------------------------------------------

    //----------------Actual line calculation-----------------------
    let actualAcres = 0, actualEndTime = null;
    if (message.detail.work.length > 0) {
        actualLine.push({ time: startOfDay, acres: actualAcres, ts: 0 });
        for (const item of message.detail.work) {
            const startTime = moment.utc(item.start).tz(timezone);
            const endTime = moment.utc(item.end).tz(timezone);
            if (!(workDayStart <= startTime && workDayEnd >= endTime)) continue;

            actualLine.push({ time: startTime, acres: actualAcres, ts: item.ts });
            actualAcres += item.acres;
            actualLine.push({ time: endTime, acres: actualAcres, ts: item.ts });
        }

        actualLine = actualLine.sort((a, b) => a.ts - b.ts);
        actualEndTime = actualLine[actualLine.length - 1].time;
        actualLine = actualLine.map(e => [graphDateString(e.time), e.acres]);
    }
    //---------------------------------------------------------------

    //-------------Trend line calculation----------------------------
    if (actualEndTime) {
        const trendEndTime = endOfDay;
        const remainingSecondsOfDay = trendEndTime.diff(actualEndTime, 'seconds');

        if (remainingSecondsOfDay > 0) {
            const workSeconds = message.summary && message.summary.work && !isNaN(message.summary.work.seconds) ? message.summary.work.seconds : 0;
            const acresPerSecond = (workSeconds > 0) ? (actualAcres / workSeconds) : 0;
            const trendAcres = (remainingSecondsOfDay * acresPerSecond);
            trendLine.push({ time: actualEndTime, acres: actualAcres, ts: actualEndTime.valueOf() });
            trendLine.push({ time: trendEndTime, acres: trendAcres, ts: trendEndTime.valueOf() });
        }

        let trendAcres = 0;
        trendLine = trendLine.sort((a, b) => a.ts - b.ts).map(e => {
            trendAcres += e.acres;
            return [graphDateString(e.time), trendAcres];
        });
    }
    //--------------------------------------------------------------

    return {
        actual: actualLine, trend: trendLine,
        ...(plannedLine.length > 0) ? { planned: plannedLine } : {}
    };
}

const historicalGraphForFarm = (planTypeId, state, message, timezone, defaultAnalyseValues) => {
    let { graph } = state.summaryByPlanTypeId[planTypeId];
    graph = graph ? graph : defaultAnalyseValues.graph;

    const planStartTime = (graph.planned.length > 0) ? graph.planned[0][0] : null;

    const getWorkDate = (start, end) => {
        if (!(start && end)) return;
        const startTime = moment.utc(start).tz(timezone);
        const endTime = moment.utc(end).tz(timezone);

        return {
            startTime, endTime, ts: startTime.valueOf(),
            day: startTime.clone().startOf('day').valueOf()
        };
    }

    //---------------------Find work window------------------------
    let workWindow = [], workDetail = [];
    for (const key in message) {
        if (!(message[key].data && Array.isArray(message[key].data))) continue;
        const data = message[key].data;

        for (const item of data) {

            if (!(item.work_day && item.work_day.start_time && item.work_day.end_time)) continue;
            const workDay = getWorkDate(item.work_day.start_time, item.work_day.end_time);
            workWindow.push(workDay);

            const acres = (item.summary && item.summary.work && !isNaN(item.summary.work.acres)) ? item.summary.work.acres : 0;
            workDetail.push({ ...workDay, acres });
        }
    }

    workWindow = workWindow.sort((a, b) => a.ts - b.ts);
    workDetail = workDetail.sort((a, b) => a.ts - b.ts);
    //--------------------------------------------------------------

    //---------------------Find work activity-----------------------
    let workActivity = [];
    const detailGrouping = groupBy('day')(workDetail);
    for (const day in detailGrouping) {
        const list = detailGrouping[day].sort((a, b) => a.day - b.day);
        let minStarTime = null, maxEndTime = null, acres = 0;

        for (const item of list) {
            if (!minStarTime || minStarTime > item.startTime) minStarTime = item.startTime;
            if (!maxEndTime || maxEndTime < item.endTime) maxEndTime = item.endTime;
            acres += item.acres;
        }

        workActivity.push({
            startTime: minStarTime, endTime: maxEndTime,
            acres, day, ts: minStarTime.valueOf()
        });
    }
    //---------------------------------------------------------------

    //----------------Planned line calculation-----------------------
    let planned = graph.planned, plannedLine = [], plannedAcres = 0, index = 0;
    const plannedActivity = graph.planned_activity;

    for (const item of plannedActivity) {
        let startTime = moment.utc(item.start_time);
        let endTime = moment.utc(item.end_time);

        const startDateStr = startTime.format(API_DATE_FORMAT);
        const findItems = workWindow.filter(e => e.startTime.format(API_DATE_FORMAT) === startDateStr);
        if (findItems.length > 0) {
            startTime = moment.utc(graphDateString(findItems[0].startTime));
            endTime = moment.utc(graphDateString(findItems[0].endTime));
        }

        if (index === 0) {
            const start = (planned.length > 0) ? moment.utc(planned[0][0]) : moment.utc(item.start_time);
            plannedLine.push({ time: graphDateString(start), acres: plannedAcres, ts: start.valueOf() });
        }

        plannedLine.push({ time: graphDateString(startTime), acres: plannedAcres, ts: startTime.valueOf() });
        plannedAcres += item.acres;
        plannedLine.push({ time: graphDateString(endTime), acres: plannedAcres, ts: endTime.valueOf() });

        if (index === plannedActivity.length - 1) {
            const end = (planned.length > 0) ? moment.utc(planned[planned.length - 1][0]) : moment.utc(item.end_time);
            plannedLine.push({ time: graphDateString(end), acres: plannedAcres, ts: end.valueOf() });
        }
        index++;
    }
    plannedLine = plannedLine.sort((a, b) => a.ts - b.ts).map(e => [e.time, e.acres]);
    //----------------------------------------------------------------

    //----------------Actual line calculation-------------------------
    let actualLine = [], totalAcres = 0;
    if (planStartTime && workActivity.length > 0) {
        actualLine.push({ time: planStartTime, acres: totalAcres, ts: 0 });

        for (const item of workActivity) {
            actualLine.push({ time: graphDateString(item.startTime), acres: totalAcres, ts: item.ts });
            totalAcres += item.acres;
            actualLine.push({ time: graphDateString(item.endTime), acres: totalAcres, ts: item.ts });
        }
        actualLine = actualLine.sort((a, b) => a.ts - b.ts).map(e => [e.time, e.acres]);
    }

    if (actualLine.length > 0 && plannedLine.length > 0) {
        const planEndTime = plannedLine[plannedLine.length - 1][0];
        const planEndUTCTime = moment.utc(planEndTime);

        const actualEndTime = actualLine[actualLine.length - 1][0];
        const actualEndUTCTime = moment.utc(actualEndTime);

        if (planEndUTCTime < actualEndUTCTime) {
            const plannedAcres = plannedLine[plannedLine.length - 1][1];
            plannedLine.push([actualEndTime, plannedAcres]);
        } else if (planEndUTCTime > actualEndUTCTime) {
            const actualAcres = actualLine[actualLine.length - 1][1];
            actualLine.push([planEndTime, actualAcres]);
        }
    }
    //-----------------------------------------------------------------

    return { planned: plannedLine, actual: actualLine, trend: [] };
}

export const mergeDeviceSensors = (deviceData, message) => {
    const utcTS = moment.utc().valueOf();

    const batteryPercent = message['battery'] ? message['battery'].percent : null;
    const connected = message['qConnection'] ? message['qConnection'].connected : null;
    const connectionUpTime = message['qConnection'] ? secondsToTime((utcTS - message['qConnection'].ts) / 1000, false, true) : null;
    const fuelLevel = message['fuelLevel'] ? message['fuelLevel'].percent : null;
    const ptoRPMSpeed = message['pto'] ? message['pto'].speed : null;
    const ptoRPMState = message['pto'] ? message['pto'].state : null;


    let newDeviceData = deviceData;
    if (batteryPercent !== null) newDeviceData = { ...newDeviceData, batteryPercent };
    if (fuelLevel !== null) newDeviceData = { ...newDeviceData, fuelLevel };
    if (connected !== null) newDeviceData = { ...newDeviceData, connected };
    if (connectionUpTime !== null) newDeviceData = { ...newDeviceData, connectionUpTime };
    if (ptoRPMSpeed !== null) newDeviceData = { ...newDeviceData, ptoRPMSpeed };
    if (ptoRPMState !== null) newDeviceData = { ...newDeviceData, ptoRPMState };

    return newDeviceData
}